import React from 'react'
import Modal from '@bit/atd.web.modal'
import Button from '@bit/atd.web.button'
import Grid from '@bit/atd.web.grid'
import { makeStyles } from '@material-ui/core/styles'
import colors from '@bit/atd.web.colors/dist/colors'

type PropsType = {
  isOpen: boolean
  setIsOpen: any
  submitHandler?: any
}

const useStyles = makeStyles({
  mainText: {
    textAlign: 'center',
    color: colors.brandOrange,
    display: 'block',
  },
})

const RemoveModal = ({ isOpen, setIsOpen, submitHandler }: PropsType) => {
  const classes = useStyles()
  return (
    <Modal
      footerNoSeparator
      headerNoSeparator
      open={isOpen}
      size="medium"
      title="Are you sure you want to remove this?"
      onClose={() => setIsOpen(false)}
      actions={
        <Grid container justify="space-around" alignItems="center">
          <Grid item>
            <Button
              variant="secondary"
              size="medium"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                submitHandler && submitHandler()
                setIsOpen(false)
              }}
            >
              Yes
            </Button>
          </Grid>
        </Grid>
      }
    >
      <span className={classes.mainText}>This action cannot be undone</span>
    </Modal>
  )
}

export default RemoveModal
